import { createLegacyModule } from "./createLegacyModule";

const keys = [
  "activity time",
  "card collecting",
  "Collect coupon immediately",
  "detail of the activity",
  "Activity ended",
  "direction for use",
  "I have read and agree",
  "Log in to view the current number of print cards",
  "package_BUY_NOW",
  "package_detail",
  "package_Introduction",
  "package_List",
  "please log in first",
  "register",
  "user",
  "valid time"
];

export default createLegacyModule(keys);
